"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var errors_1 = require("../errors");
var validateCarMake = function (make) {
    if (!make || typeof make !== 'string') {
        throw new errors_1.ValidationError({
            code: 'E_INVALID_PARAMETER',
            field: 'make',
            message: 'Invalid `car.make` value.',
            type: 'bad_request',
        });
    }
    return make;
};
var validateCarModel = function (model) {
    if (!model || typeof model !== 'string') {
        throw new errors_1.ValidationError({
            code: 'E_INVALID_PARAMETER',
            field: 'model',
            message: 'Invalid `car.model` value.',
            type: 'bad_request',
        });
    }
    return model;
};
var validateCarYear = function (year) {
    if (!year || typeof year !== 'number') {
        throw new errors_1.ValidationError({
            code: 'E_INVALID_PARAMETER',
            field: 'year',
            message: 'Invalid `car.year` value.',
            type: 'bad_request',
        });
    }
    return year;
};
var valdiateCarVersion = function (version) {
    if (!version || typeof version !== 'string') {
        throw new errors_1.ValidationError({
            code: 'E_INVALID_PARAMETER',
            field: 'version',
            message: 'Invalid `Car.version` value.',
        });
    }
    return version;
};
exports.default = (function (_a) {
    var carsAdapter = _a.carsAdapter;
    return {
        makeExists: function (car) {
            return __awaiter(this, void 0, void 0, function () {
                var makes;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            car.make = validateCarMake(car.make);
                            return [4 /*yield*/, this.getMakes()];
                        case 1:
                            makes = _a.sent();
                            return [2 /*return*/, makes.indexOf(car.make) > -1];
                    }
                });
            });
        },
        getMakes: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, carsAdapter.getMakes()];
                });
            });
        },
        modelExists: function (car) {
            return __awaiter(this, void 0, void 0, function () {
                var models;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            car.make = validateCarMake(car.make);
                            car.model = validateCarModel(car.model);
                            return [4 /*yield*/, this.getModels(car)];
                        case 1:
                            models = _a.sent();
                            return [2 /*return*/, models.indexOf(car.model) > -1];
                    }
                });
            });
        },
        getModels: function (car) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, carsAdapter.getModels(car)];
                });
            });
        },
        yearExists: function (car) {
            return __awaiter(this, void 0, void 0, function () {
                var years;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            car.make = validateCarMake(car.make);
                            car.model = validateCarModel(car.model);
                            car.year = validateCarYear(car.year);
                            return [4 /*yield*/, this.getYears(car)];
                        case 1:
                            years = _a.sent();
                            return [2 /*return*/, years.indexOf(car.year) > -1];
                    }
                });
            });
        },
        getYears: function (car) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, carsAdapter.getYears(car)];
                });
            });
        },
        versionExists: function (car) {
            return __awaiter(this, void 0, void 0, function () {
                var versions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            car.make = validateCarMake(car.make);
                            car.model = validateCarModel(car.model);
                            car.year = validateCarYear(car.year);
                            car.version = valdiateCarVersion(car.version);
                            return [4 /*yield*/, this.getVersions(car)];
                        case 1:
                            versions = _a.sent();
                            return [2 /*return*/, versions.indexOf(car.version) > -1];
                    }
                });
            });
        },
        getVersions: function (car) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, carsAdapter.getVersions(car)];
                });
            });
        },
        addVersion: function (car) {
            return __awaiter(this, void 0, void 0, function () {
                var isDuplicated;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.versionExists(car)];
                        case 1:
                            isDuplicated = _a.sent();
                            if (isDuplicated) {
                                throw new errors_1.CoreError({
                                    field: 'version',
                                    message: "Duplicated car version, the version `" + car.version + "` already exists.",
                                    code: 'E_DUPLICATED_PARAM',
                                    type: 'bad_parameter',
                                });
                            }
                            return [2 /*return*/, carsAdapter.addVersion(car)];
                    }
                });
            });
        },
        updateVersion: function (car, newVersion) {
            return __awaiter(this, void 0, void 0, function () {
                var resourceExists, isDuplicated;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.versionExists(car)];
                        case 1:
                            resourceExists = _a.sent();
                            if (!resourceExists) {
                                throw new errors_1.CoreError({
                                    field: 'version',
                                    message: "Car version `" + car.version + "` does not exists.",
                                    code: 'E_RESOURCE_NOT_FOUND',
                                    type: 'not_found'
                                });
                            }
                            return [4 /*yield*/, this.versionExists(__assign({}, car, { version: newVersion }))];
                        case 2:
                            isDuplicated = _a.sent();
                            if (isDuplicated) {
                                throw new errors_1.CoreError({
                                    field: 'version',
                                    message: "Duplicated car version, the version `" + car.version + "` already exists.",
                                    code: 'E_DUPLICATED_PARAM',
                                    type: 'bad_parameter',
                                });
                            }
                            return [2 /*return*/, carsAdapter.updateVersion(car, newVersion)];
                    }
                });
            });
        },
        removeVersion: function (car) {
            return __awaiter(this, void 0, void 0, function () {
                var resourceExists;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.versionExists(car)];
                        case 1:
                            resourceExists = _a.sent();
                            if (!resourceExists) {
                                throw new errors_1.CoreError({
                                    field: 'version',
                                    message: "Car version `" + car.version + "` does not exists.",
                                    code: 'E_RESOURCE_NOT_FOUND',
                                    type: 'not_found'
                                });
                            }
                            return [2 /*return*/, carsAdapter.removeVersion(car)];
                    }
                });
            });
        }
    };
});
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../@core/dist/services/specifications.js
// module id = 881
// module chunks = 0